import { useDispatch } from 'react-redux';
import { LocalizedText, showSuccessAlert, useGainsightService } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { setProductServiceOrders } from '@mews-commander/legacy-entities/src/ducks/productServiceOrders';
import { trackNegativeAmountSubmitted } from '../actions/actions';

export interface SubmitHandlers {
    onSubmitting?: () => void;
    onSubmitted?: () => void;
    onSuccess?: () => void;
}

export const useProductServiceOrdersAdd = ({ onSubmitting, onSubmitted, onSuccess }: SubmitHandlers) => {
    const dispatch = useDispatch();
    const gainSightService = useGainsightService();

    return useRepositoryMutation('productServiceOrders', 'add', {
        onMutate: () => {
            onSubmitting?.();
        },
        onSettled: () => {
            onSubmitted?.();
        },
        onSuccess: ({ productServiceOrders }, variables) => {
            if (productServiceOrders.length) {
                dispatch(setProductServiceOrders(productServiceOrders));
                trackNegativeAmountSubmitted(gainSightService, variables.productServiceOrders[0]);
            }

            showSuccessAlert({
                description: (
                    <LocalizedText
                        textKey={TextKey.AddServiceToReservationSuccessAlert}
                        substitutes={{ count: productServiceOrders.length }}
                    />
                ),
            });

            onSuccess?.();
        },
    });
};
